import PropTypes from 'prop-types';

export const CtaPropTypes = {
	url: PropTypes.string.isRequired,
	text: PropTypes.shape({
		label: PropTypes.string.isRequired,
		color: PropTypes.string,
		hoverColor: PropTypes.string,
	}).isRequired,
	background: PropTypes.shape({
		color: PropTypes.string,
		hoverColor: PropTypes.string,
	}),
	isNofollow: PropTypes.bool,
};
